// extracted by mini-css-extract-plugin
export default {"recent-reports":"RecentReports_recent-reports__TEOfv"};